<template>
  <div :class="classList" class="c-input">
    <label v-if="text" :for="id" class="c-input__label block pb-1 font-body2 text-basic-subtitle">
      {{ text }}<span v-if="required" class="text-error">*</span>
    </label>
    <div class="relative flex">
      <c-icon
        v-if="icon"
        :disabled="disabled"
        :icon="icon"
        class="c-input__icon absolute top-0 bottom-0 ltr:left-3 rtl:right-3 z-10 my-auto" color="medium"
        size="compact"
      />
      <c-icon
        v-if="iconTrailing"
        :disabled="disabled"
        :icon="iconTrailing"
        :turn="turn"
        class="c-input__trailing absolute top-0 bottom-0 ltr:right-3 rtl:left-3 z-10 my-auto" color="medium"
        size="compact"
      />
      <input
        ref="input"
        :id="id"
        v-model="propValue"
        :disabled="disabled"
        :name="name"
        :placeholder="placeholder"
        :required="required"
        :type="type"
        class="c-input__input grow shrink px-3 h-9 w-52 font-body2 text-basic-medium bg-white rounded-md border border-basic-outline shadow-sm focus:border-primary-text invalid:border-error-text invalid:text-error-text disabled:border-disabled-line disabled:text-disabled-disabled disabled:shadow-none"
        v-bind="$attrs"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
import CIcon from '@/components/CIcon'
import { props } from './props'
import { computed, ref, toRefs } from 'vue'
import getIdElement from 'dcode/functions/getIdElement'
import useWatch from 'dcode/uses/useWatch'

export default {
  name: 'CInput',
  inheritAttrs: false,
  components: { CIcon },
  props,
  emits: ['input'],
  setup (props, context) {
    const { value } = toRefs(props)

    const id = `input-${getIdElement()}`
    const input = ref(undefined)
    const propValue = useWatch(value, () => value.value, ['init'])

    const classList = computed(() => {
      return {}
    })

    const onInput = event => context.emit('input', event.target.value)

    return {
      id,
      input,
      propValue,
      classList,
      onInput
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
